module.exports = __webpack_public_path__ + "img/v2.d66f7489.webp";